import { React, useEffect, useState } from 'react';

const NavBar = (props) => {
  const activeSection = props.activeSection;

  const sections = ["projects", "publications", "teaching", "contact"];



  //const [visible, setVisible] = useState(true);
  /*useEffect(() => {
    function onScrollEvent(e) {
      //if (window.innerWidth > 640) return;

      const winScroll = document.documentElement.scrollTop;
      if (parseInt(winScroll) > 10) {
        visible && setVisible(false);
      } else {
        setVisible(true);
      }
    }

    window.addEventListener("scroll", onScrollEvent);

    return () =>
      window.removeEventListener("scroll", onScrollEvent);

  }, []);*/

  return (


    <header className={`-top-50 bg-zinc-900 sticky sm:top-0 z-10 justify-items-center 
    text-center justify-center`}>

      <div className={`
      lg:w-1024 
      sm:w-full 
      bg-zinc-900 
      mx-auto 
      flex 
      flex-wrap 
      py-3
      sm:py-5 
      px-8 flex-col md:flex-row justify-items-center text-center justify-center`}>
        <p className={`text-2xl leading-normal
          font-medium justify-items-center text-center justify-center text-white mb-4 md:mb-0`}>
          Andrea Bellucci
        </p>

        <nav className="flex-raw md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-300 flex items-center text-lg text-center justify-center">
          {
            sections.map((section, i) => {
              if (activeSection === i) {
                return (
                  <p key={i} className="mr-4 text-white">
                    {section}
                  </p>
                )
              } else {
                return (
                <a key={i} href={`#${section}`} className="mr-4 text-amber-400 hover-hover:hover:text-gray-300">
                   {section}
                </a> 
                )
              }
            })
          }
            
          
          
          {/*<a href="#projects" id="a-projects" className="mr-5 text-amber-400 hover-hover:hover:text-gray-500">
            Projects
          </a>
          <a href="#publications" id="a-publications" className="mr-5 text-amber-400 hover-hover:hover:text-gray-500">
            Publications
          </a>
          <a href="#teaching" id="a-teaching" className="mr-5 text-amber-400 hover-hover:hover:text-gray-500">
            Teaching
          </a>
          <a href="#contact" id="a-contact" className="mr-5 text-amber-400 hover-hover:hover:text-gray-500">
            Contact
          </a>*/}
        </nav>
      </div>
    </header>

  )
};

NavBar.propTypes = {};

NavBar.defaultProps = {};

export default NavBar;
